/* eslint-disable import/order */
import { MenuIdStatusPageManage } from '@jira/navigation-apps__constants/src/MenuIdStatusPageManage.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { communicationsStatusPageCreateRoute } from '@jira/router-routes__communications-routes/src/communicationsStatusPageCreateRoute.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { StatusPageCreatePageEntryPoint } from './ui/status-page-create/StatusPageCreatePageEntryPoint.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const communicationsStatusPageCreateRouteEntry: Route = createEntry(
	communicationsStatusPageCreateRoute,
	() => ({
		group: 'communications',
		navigation: {
			menuId: MenuIdStatusPageManage,
		},
		entryPoint: () => {
			return fg('communications_status_page_manage_platform')
				? StatusPageCreatePageEntryPoint
				: undefined;
		},
		resources: [...getNavigationResources()],
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
